import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=b0c70948&scoped=true&"
import script from "./PriceSummary.vue?vue&type=script&lang=js&"
export * from "./PriceSummary.vue?vue&type=script&lang=js&"
import style0 from "./PriceSummary.vue?vue&type=style&index=0&id=b0c70948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c70948",
  null
  
)

export default component.exports